var React = require('react');

function GuarantorArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Arrow","transform":"translate(2.828 1.414)"},React.createElement("path",{"id":"Arrow-2","data-name":"Arrow","d":"M24,0,12,12,0,0","transform":"translate(12) rotate(90)","fill":"none","stroke":"#253746","strokeMiterlimit":"10","strokeWidth":"4","opacity":"0.9"})));
}

GuarantorArrowLeft.defaultProps = {"width":"16.243","height":"26.829","viewBox":"0 0 16.243 26.829"};

module.exports = GuarantorArrowLeft;

GuarantorArrowLeft.default = GuarantorArrowLeft;
